<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-class :resources="resources"></list-class>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <!-- <ion-fab vertical="bottom" horizontal="end" slot="fixed" edge>
      <ion-fab-button @click="setCreateModalState(true)">
        <ion-icon :ios="addOutline" :md="addOutline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-modal
      :is-open="createModalState"
      @didDismiss="setCreateModalState(false)"
    >
      <base-modal
        title="Create section"
        @closeModal="setCreateModalState(false)"
      >
        <create-class
          @closeModal="setCreateModalState(false)"
        ></create-class>
      </base-modal>
    </ion-modal> -->
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
// import BaseModal from "../../Base/BaseModal";
import ListClass from "../../Components/Attendance/ListClass.vue";
// import ListClass from "../../Components/Setup/Class/ListClass";
// import CreateClass from "../../Components/Setup/Class/CreateClass";

import {
  IonGrid,
  IonRow,
  IonCol,
//   IonFab,
//   IonIcon,
//   IonFabButton,
//   IonModal,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

import { addOutline } from "ionicons/icons";

export default {
  components: {
    BaseLayout,
    // BaseModal,
    ListClass,
    // CreateClass,
    IonGrid,
    IonRow,
    IonCol,
    // IonFab,
    // IonIcon,
    // IonFabButton,
    // IonModal,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Attendance",
      backLink: "dashboard",
      reloadable: true,

      createModalState: false,

      addOutline,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["attendanceClass/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = false) {
      await this.$store.dispatch("attendanceClass/resources", { refresh: refresh });
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("attendanceClass/resources", { refresh: true });
      if (event) {
        event.target.complete();
      }
    },
    setCreateModalState(state) {
      this.createModalState = state;
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style scoped>
</style>
